import React, { useState } from 'react'
import { TextField, Stack, Button } from '@mui/material'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { AxiosWithAuth } from '../../../Utilities/authenticationService'
import ButtonWithConfirmPrompt from '../../ButtonWithConfirmPrompt'
import PageWithTitleLayout from '../../Layout/PageWithTitleLayout'
import { validateHiraganaKatakana } from '../../../Utilities/fieldValidators'

const EditNickname = ({ current, handleReturn, propsId }) => {
    const { userId } = useParams()
    const [newValue, setNewValue] = useState({ nickname: current.nickname || '' })
    const [errors, setErrors] = useState({})

    const handleNickname = event => {
        const text = event.target.value
        if (!validateHiraganaKatakana(text)) {
            setErrors({ ...errors, nickname: '全角ひらがな・全角カタカナ' })
        } else {
            //eslint-disable-next-line
            const { nickname, ...rest } = errors
            setErrors(rest)
        }
        setNewValue({ ...newValue, nickname: text })
    }
    return (
        <PageWithTitleLayout title="ニックネームの変更">
            <Stack spacing={2} sx={{ m: '1rem' }} className="shrinkable">
                <TextField
                    label="ニックネーム"
                    placeholder={`例：${current.nickname || 'ジョン'}`}
                    helperText={errors.nickname || '全角ひらがな・全角カタカナ'}
                    InputLabelProps={{ shrink: true }}
                    value={newValue.nickname}
                    onChange={e => setNewValue({ ...newValue, nickname: e.target.value })}
                    error={errors.nickname}
                    inputProps={{ onBlur: handleNickname }}
                />
            </Stack>
            <ButtonWithConfirmPrompt
                component={
                    <Button
                        variant="contained"
                        color="paloBlue"
                        className="shrinkable"
                        sx={{ mx: '1rem', mt: 'auto', mb: '2rem' }}
                    >
                        変更して保存する
                    </Button>
                }
                title="ニックネームの変更"
                content="ニックネームを変更してもよろしいですか？"
                confirmText="変更する"
                handleConfirm={() => {
                    AxiosWithAuth.put('/users/' + (userId || propsId), {
                        nickname: newValue.nickname
                    })
                        .then(res => {
                            res.status == 200 && handleReturn()
                        })
                        .catch(error => {
                            const errors = {}
                            for (const [key, value] of Object.entries(error?.response?.data)) {
                                errors[key] = value.join(' ')
                            }
                            setErrors(errors)
                        })
                }}
            />
        </PageWithTitleLayout>
    )
}
export default EditNickname
